<app-layout>
  <app-voltar route="listagem/motoristas-externo" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          label="ID Motorista"
          name="PK_MTRT"
          formControlName="PK_MTRT"
          placeholder="Digite aqui"
          maxLength="40"
          [disabled]="true"></app-input>

        <app-input
          label="Nome Completo"
          name="NM_MTRT"
          formControlName="NM_MTRT"
          placeholder="Digite aqui"
          maxLength="40"
          [disabled]="true"></app-input>

        <app-input
          label="CPF"
          name="TX_CPF_MTRT"
          formControlName="TX_CPF_MTRT"
          placeholder="Digite aqui"
          mask="000.000.000-00"
          placeholder="___.___.___-__"
          [disabled]="true"></app-input>

        <app-input
          label="CNH"
          name="TX_CNH_MTRT"
          formControlName="TX_CNH_MTRT"
          placeholder="Digite aqui"
          mask="000.000.000-00"
          placeholder="___.___.___-__"
          [disabled]="true"></app-input>

        <app-input
          type="email"
          label="E-mail"
          name="TX_MAIL_MTRT"
          formControlName="TX_MAIL_MTRT"
          placeholder="Digite aqui"
          maxLength="50"
          [disabled]="true"></app-input>

        <app-input
          label="CEP"
          name="TX_ENDE_CEP_MTRT"
          formControlName="TX_ENDE_CEP_MTRT"
          placeholder="_____-___"
          mask="00000-000"
          [disabled]="true"></app-input>

        <app-input
          label="Estado"
          name="TX_ENDE_ESTD_MTRT"
          formControlName="TX_ENDE_ESTD_MTRT"
          placeholder="Digite aqui"
          maxLength="2"
          [disabled]="true"></app-input>

        <app-input
          label="Cidade"
          name="TX_ENDE_CDDE_MTRT"
          formControlName="TX_ENDE_CDDE_MTRT"
          placeholder="Digite aqui"
          maxLength="50"
          [disabled]="true"></app-input>

        <app-input
          label="Endereço"
          name="TX_ENDE_RUA_MTRT"
          formControlName="TX_ENDE_RUA_MTRT"
          placeholder="Digite aqui"
          maxLength="50"
          [disabled]="true"></app-input>
      </div>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
